import { MapArtifactToSlides } from 'interfaces/jobs/basic';

export interface QaAnalysisJobConfig {
  pipsCellsTablesArtifactUrls: MapArtifactToSlides[];
  markers: string[];
  assignmentIds: number[];
  manifest: string[];
}

export interface QaAnalysisFormValues {
  jobName: string;
  jobDescription: string;
  configParams: QaAnalysisJobConfig;
}

export enum RunQaAnalysisStep {
  LoadParams = 'Reuse Previous Job Settings',
  NameAndDescription = 'Name and Description',
  SelectInferenceModels = 'Select Post Processing - Cell Typing',
  AdditionalParameters = 'Analysis Settings',
}

export const runQaAnalysisOrder = [
  RunQaAnalysisStep.LoadParams,
  RunQaAnalysisStep.NameAndDescription,
  RunQaAnalysisStep.SelectInferenceModels,
  RunQaAnalysisStep.AdditionalParameters,
];
